export interface WaitlistForm {
  name: string;
  email: string;
  company: string;
  role: string;
  phone: string;
  companyType: string;
  companySize: string;
  headquarters: string;
  trialPhase: string[];
  therapeuticAreas: string[];
  targetCountries: string[];
  expectedTrials: string;
  timeframe: string;
  budgetRange: string;
  specificRequirements: string;
  hearAboutUs: string;
}

export const initialWaitlistForm: WaitlistForm = {
  name: '',
  email: '',
  company: '',
  role: '',
  phone: '',
  companyType: '',
  companySize: '',
  headquarters: '',
  trialPhase: [],
  therapeuticAreas: [],
  targetCountries: [],
  expectedTrials: '',
  timeframe: '',
  budgetRange: '',
  specificRequirements: '',
  hearAboutUs: '',
};
